"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//read tenant base url from cookie
_axios.default.defaults.baseURL = _jsCookie.default.get('tenantUrl');
_axios.default.defaults.withCredentials = true;
_axios.default.defaults.xsrfCookieName = 'csrfToken';
_axios.default.defaults.headers = {
  'content-type': 'application/json'
}; //read tenant base url from cookie
// Add Axios interceptor globally to remove trailing slashes

_axios.default.interceptors.request.use(function (config) {
  if (config.url) {
    config.url = config.url.replace(/\/+$/, ''); // Remove trailing slashes
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

var create = function create(url, data, config) {
  return _axios.default.post("".concat(url), data, config);
};

var remove = function remove(url, config) {
  return _axios.default.delete("".concat(url), config);
};

var update = function update(url, data, config) {
  return _axios.default.patch("".concat(url), data, config);
};

var put = function put(url, data, config) {
  return _axios.default.put("".concat(url), data, config);
};

var get = function get(url, config) {
  return _axios.default.get("".concat(url), config);
};

var ApiServices = {
  get: get,
  post: create,
  patch: update,
  delete: remove,
  put: put
};
var _default = ApiServices;
exports.default = _default;